import type { Feature } from '@luna/gatekeeper';

export const cardDetails: Feature = {
    enabled: true,
    _description:
        'Displays card details card in the card services section in the bank card settings page and credit card functions page',
};

export const cardDetailsEncryption: Feature = {
    enabled: true,
    _description: 'Enables new JWE secured info encryption',
};
